import { Component ,Input} from '@angular/core';
import { UploadModalService } from './uploadmodal.service';
import { FinDeNavListFilesRequest, ClientInvoice } from '../Models/Invoice';
import * as XLSX from 'xlsx';
import { X } from 'lucide-angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { OverlayRef } from '@angular/cdk/overlay';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
// interface ClientInvoice {
//   clientName: string;
//   //invoice: string;
//   invoiceList: string[];
// }

@Component({
  selector: 'app-uploadmodal',
  templateUrl: './uploadmodal.component.html',
  styleUrls: ['./uploadmodal.component.scss'],
  standalone: false,
})
export class UploadmodalComponent {
  @Input() title = 'Finance de Nav';
  @Input() message = 'Default message';

  readonly X = X;

  textInput: string = '';
  fileName: string = '';
  invoices: ClientInvoice[] = [];
  uploadedFile: File | null = null;
  isLoading: boolean = false;
  notes: string = '';
  isGenerating = true;


 constructor(private uploadModalService: UploadModalService, private spinner: NgxSpinnerService, private overlayRef: OverlayRef) {}

  generateZip() {
    console.log('Generating zip from text:', this.textInput);

    //this.notes = 'Test';
    //   //this.total = 10;
      // Store the incoming excel first; if that fails the import still goes ahead without it.
      const storeFile$ = this.uploadedFile
        ? this.uploadModalService.storeImportFile(this.uploadedFile)
        : of(null);

      const hasFile = !!this.uploadedFile;
      storeFile$
        .pipe(switchMap(stored => {
          if (hasFile && !stored) {
            alert('The original Excel file could not be stored. The import will continue, but the file will not be available for download.');
          }
          return this.uploadModalService.generateZip(
            this.fileName, this.invoices, this.notes, stored?.id ?? '', stored?.importS3Path ?? null);
        }))
        .subscribe({
          next: (response) => {
            //alert('Save success');
            //this.activeModal.close();
            this.clearForm();
            console.log('Save successful', response);
            this.isGenerating = true;
            this.submit()
          },
          error: (error) => {
            console.error('Error saving data', error);
            alert('Save failed. Please try again.');
          }
        });

    // For demo purposes: simple log
    // In a real app, use JSZip or a service to generate and download a zip file
  }

  clearForm() {
    this.fileName = '';
    this.invoices = [];
    this.notes = '';
    this.uploadedFile = null;
  }

onDragOver(event: DragEvent) {
  event.preventDefault();
}

onFileDrop(event: DragEvent) {
  event.preventDefault();

  const files = event.dataTransfer?.files;
  if (files && files.length > 0) {
    const file = files[0];
    const fileName = file.name;
    const extension = fileName.split('.').pop()?.toLowerCase();

    console.log('onFileDrop');

    if (extension === 'xls' || extension === 'xlsx') {
      this.fileName = fileName;
      this.uploadedFile = file;
      this.isLoading = true; // not needed
      this.spinner.show();
      setTimeout(() => {
        const reader = new FileReader();

        reader.onload = (e: any) => {
          const arrayBuffer: ArrayBuffer = e.target.result;
          const data = new Uint8Array(arrayBuffer);
          const workbook: XLSX.WorkBook = XLSX.read(data, { type: 'array' });

          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];

          const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as string[][];
          this.parseExcelData(sheetData);
          this.isLoading = false;
          this.spinner.hide();
        };

        reader.onerror = () => {
          alert('Failed to read file');
          this.isLoading = false;
          this.spinner.hide();
        };

        reader.readAsArrayBuffer(file);
      }, 0);

    } else {
      alert('Only Excel files (.xls, .xlsx) are allowed.');
      this.fileName = '';
      this.uploadedFile = null;
      this.invoices = [];
    }
  }
}

//onFileSelect(event: Event) {
  onFileSelect(event: any): void {
  // const input = event.target as HTMLInputElement;
  // if (input.files && input.files.length > 0) {
  //   this.fileName = input.files[0].name;
  // }

  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    const file = input.files[0];
    const fileName = file.name;
    const extension = fileName.split('.').pop()?.toLowerCase();

    if (extension === 'xls' || extension === 'xlsx') {
      //this.fileName = fileName;


      // Proceed with your logic
      const file = event.target.files[0];
  this.fileName = file.name;
  this.uploadedFile = file;
  this.isLoading = true;
  this.spinner.show();

  setTimeout(() => {
  const reader = new FileReader();

  reader.onload = (e: any) => {
    const arrayBuffer: ArrayBuffer = e.target.result;
    const data = new Uint8Array(arrayBuffer);
    const workbook: XLSX.WorkBook = XLSX.read(data, { type: 'array' });

    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];

    const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as string[][];
    this.parseExcelData(sheetData);
    this.isLoading = false;
    this.spinner.hide();
  };

  reader.onerror = () => {
    alert('Failed to read file');
    this.isLoading = false;
    this.spinner.hide();
  };
  reader.readAsArrayBuffer(file);
}, 0);

    } else {
      alert('Only Excel files (.xls, .xlsx) are allowed.');
      input.value = ''; // Reset the file input
      this.fileName = '';
      this.uploadedFile = null;
      this.isLoading = false;
    }
  }
}

parseExcelData(data: string[][]): void {
  this.invoices = [];

  const clientMap = new Map<string, string[]>();
  let currentClient = '';

  for (let i = 1; i < data.length; i++) { // Skip header row
    const [clientCell, invoiceCell_temp] = data[i];
    const invoiceCell = invoiceCell_temp?.toString();

    // If clientCell has value, update currentClient
    if (clientCell && clientCell.trim()) {
      currentClient = clientCell.trim();
    }

    // If invoiceCell has value, add it to current client's invoice list
    if (invoiceCell && invoiceCell.trim()) {
      if (!clientMap.has(currentClient)) {
        clientMap.set(currentClient, []);
      }
      clientMap.get(currentClient)!.push(invoiceCell.trim());
    }
  }
  // Convert map to array of ClientInvoice objects
  this.invoices = Array.from(clientMap.entries()).map(([clientName, invoiceList]) => ({
    clientName,
    invoiceList: [...new Set(invoiceList)]  // remove duplicates
  }));
  this.isGenerating = false;
  console.log(this.invoices);
}


// get invoiceText(): string {
//   return this.invoices
//     .map(i => `${i.clientName}\n${i.invoiceList.join('\n')}`)  // each invoice on new line
//     .join('\n\n');  // separate clients by a blank line
// }


// get invoiceText(): string {
//   return this.invoices
//     .map(i => `${i.clientName}\t${i.invoiceList.join(', ')}`)  // join invoiceList array as comma-separated string
//     .join('\n');
// }

get invoiceText(): string {
  return this.invoices
    .map(client => {
      // First line: client name + first invoice
      const firstLine = `${client.clientName.padEnd(8, ' ')}${client.invoiceList[0]}`;
      // Other invoices: indent with spaces to align under invoice column
      const otherLines = client.invoiceList
        .slice(1)
        .map(inv => ' '.repeat(8) + inv)
        .join('\n');
      // Join first line and other lines, skip if no other invoices
      return otherLines ? `${firstLine}\n${otherLines}` : firstLine;
    })
    .join('\n\n');  // blank line between clients
}


// saveInvoices() {
//   this.notes = 'Test';
//   //this.total = 10;
//   this.uploadModalService.generateZip(this.fileName, this.invoices, this.notes)
//     .subscribe({
//       next: (response) => {
//         console.log('Save successful', response);
//       },
//       error: (error) => {
//         console.error('Error saving data', error);
//       }
//     });
// }


  submit() {
    console.log('Submitted text:', this.textInput);
    console.log('Submitted file:', this.uploadedFile?.name || 'No file selected');
    this.close(); // closing the modal
    // You can send this data back or make an API call here
    /* this.activeModal.close({
      text: this.textInput,
      file: this.uploadedFile
    }); */
  }

  close() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
    }
  }
}
